<template>
  <page-tabs
      :tabs="tabs"
  >
    <template v-slot:default="{tabSelected}">
      <settings-divs v-if="tabSelected==='settingsDivs'"/>
      <settings-spec v-if="tabSelected==='settingsSpec'"/>
      <settings-med-record v-if="tabSelected==='settingsMedRecord'"/>
      <settings-medias v-if="tabSelected==='settingsMedias'"/>
      <insurs v-if="tabSelected==='insurs'"/>
      <tags v-if="tabSelected==='tags'"/>
      <settings-salary-templates  v-if="tabSelected==='settingsSalaryTemplates'"/>
      <settings-logs v-if="tabSelected==='settingsLog'"/>
      <settings-monitor v-if="tabSelected==='settingsMonitor'"/>
    </template>
  </page-tabs>
</template>

<script>
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import SettingsDivs from "@/views/Settings/SettingsDivs";
import SettingsSpec from "@/views/Settings/SettingsSpec";
import SettingsMedRecord from "@/views/Settings/SettingsMedRecord";
import SettingsMedias from "@/views/Settings/SettingsMedias";
import Insurs from "@/views/Insur/Insurs.vue";
import Tags from "@/views/Tag/Tags.vue";
import SettingsMonitor from "@/views/Settings/SettingsMonitor.vue";
import SettingsSalaryTemplates from "@/views/Settings/SettingsSalaryTemplates.vue";
import SettingsLogs from "./SettingsLogs.vue";
export default {
  components: {
    SettingsLogs,
    PageTabs, SettingsMonitor, Insurs, SettingsMedias, SettingsMedRecord, SettingsSpec, SettingsDivs, Tags, SettingsSalaryTemplates},
  data:()=>({
    tabs:[
      { 
        name: 'settingsDivs', 
        perm: 'settingsComstruct', 
        label: 'Структура филиалов', 
      },
      { 
        name: 'settingsSpec', 
        perm: 'settingsSpec', 
        label: 'Специальности', 
      },
      { 
        name: 'settingsMedRecord', 
        perm: 'settingsMedrecordTemplate', 
        label: 'Шаблоны Мед.Карты', 
      },
      { 
        name: 'settingsMedias', 
        perm: 'settingsDocTemplate', 
        label: 'Шаблоны документов', 
      },
      { 
        name: 'insurs', 
        perm: 'settingsOrg', 
        label: 'Страховые организации', 
      },
      { 
        name: 'tags', 
        perm: 'settingsTag', 
        label: 'Теги', 
      },
      { 
        name: 'settingsSalaryTemplates', 
        perm: 'settingsSalaryTemplate', 
        label: 'Профили зарплаты', 
      },
      { 
        name: 'settingsLog',
        perm: 'settingsLog',
        label: 'Логирование',
      },
      {
        name: 'settingsMonitor',
        perm: 'settingsMonitor',
        label: 'Мониторинг',
      },
    ]
  }),
}
</script>